import React from 'react';
import { Box, Typography } from '@mui/material';
import EventRecommendationRow from './EventRecommendationRow';

const EventRecommendationsSection = ({ recommendations, onView }) => (
  <Box sx={{ width: '100%' }}>
    {recommendations.map((rec, idx) => (
      <EventRecommendationRow key={rec.eventTitle || idx} recommendation={rec.event} onView={onView} />
    ))}
  </Box>
);

export default EventRecommendationsSection; 